import PropTypes from 'prop-types';
import React from 'react';

import { formatNumberWithDelimiter } from 'ravenjs/utils/number';

import { RangeText } from './styles';

/*
 * Renders the "x-y of total" range text (e.g. `1-5 of 13`) for the Quartz
 * pagination footer.
 */
function PaginationBarRange({ currentPage, rowsPerPage, totalRows }) {
    const safeTotal = totalRows || 0;
    const start = safeTotal === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    const end = Math.min(currentPage * rowsPerPage, safeTotal);
    const total = formatNumberWithDelimiter(safeTotal);

    return <RangeText>{`${start}-${end} of ${total}`}</RangeText>;
}

PaginationBarRange.propTypes = {
    currentPage: PropTypes.number,
    rowsPerPage: PropTypes.number,
    totalRows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

PaginationBarRange.defaultProps = {
    currentPage: 1,
    rowsPerPage: 10,
    totalRows: 0,
};

export default PaginationBarRange;
